import { Button, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import React, { useState } from 'react';
import { Listing } from 'src/api/v1-api';
import useRequest from 'src/utils/hooks/useRequest';
import DeactivateListingButton from '../deactivate-listing-button';

const SelectListingStatus = ({ listing }: { listing: Listing }) => {
  const { api } = useRequest();
  const [listingStatus, setListingStatus] = useState(listing.status);
  const editableAdminListingStatusOptions = [
    { value: 'active', name: 'Active' },
    { value: 'admin_deactivated', name: 'Admin Deactivated' },
    { value: 'pending_payment', name: 'Pending Payment' },
    { value: 'draft', name: 'Draft' },
  ];

  const updateListingStatus = async (status: string) => {
    if (status === listingStatus) return;
    if (!listing.marketplace_account?.marketplace_id) return;
    const confirmMessage = `Are you sure you want to change the listing status from ${listingStatus} to ${status}?`;
    if (window.confirm(confirmMessage)) {
      setListingStatus(status);
      const response = await api.listings.admin_set_status(
        listing.id,
        listing.marketplace_account.marketplace_id,
        { status: status },
      );

      // Append useClient=true to current URL and reload
      const url = new URL(window.location.href);
      url.searchParams.set('useClient', 'true');
      window.location.href = url.toString();
    }
  };

  // Only use the dropdown for the following statuses, otherwise show the "Remove" button
  if (!['active', 'admin_deactivated', 'pending_payment', 'draft'].includes(listingStatus)) {
    return <DeactivateListingButton listing={listing} />;
  }

  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<ChevronDownIcon fontSize="lg" color="black" />}
        size="xs"
        border="1px solid"
        py={0}
        colorScheme="black"
        variant="outline"
      >
        Change Status
      </MenuButton>
      <MenuList>
        {editableAdminListingStatusOptions.map((option) => (
          <MenuItem
            key={option.value}
            onClick={() => updateListingStatus(option.value)}
            fontWeight={option.value === listingStatus ? 'bold' : 'normal'}
          >
            {option.name}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default SelectListingStatus;
